module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [(_vm.canAccess('Setting-view')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updatelogo($event)
      }
    }
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid img-circle",
    attrs: {
      "src": _vm.logo,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v(_vm._s(_vm.getRecord.shortName))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center"
  }, [_vm._v("\n                              " + _vm._s(_vm.getRecord.companyName) + "\n                            ")]), _vm._v(" "), (_vm.canAccess('Setting-logo')) ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadImage($event)
      }
    }
  }) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid img-circle",
    attrs: {
      "src": _vm.favicon,
      "alt": "User profile picture"
    }
  }), _vm._v(" "), (_vm.canAccess('Setting-favicon')) ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFavicon($event)
      }
    }
  }) : _vm._e()])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border label-info"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Company Profile Edit")]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [(_vm.canAccess('Setting-update')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProfile
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-stripped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Website")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.website))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Software URL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.url))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Company Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.companyName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Short Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.shortName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("UPI ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.upiId))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CIBIL Member Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.cibilMemberCode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CIBIL Member Short Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.cibilMemberShortName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("About")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.getRecord.about) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CIN")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.cin))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("PAN")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.pan))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("TAN")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.tan))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("GST No")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.gstin))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Category")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.companyCategory))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Class")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.companyClass))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Authorized Capital")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.authrizedCapital))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paid Up Capital")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.paid_upCapital))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Share Nominal Value")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.shareNominalValue))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("State of Registration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.stateOfRegistration))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Incorporation Country")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.country))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Incorporation Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.incorporationDate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Contact Number 1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.mobile))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Contact Number 2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.phone))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Landline No")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.landline))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Address")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.getRecord.address) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.getRecord.city) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.pin))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("State")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.state))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-stripped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Session")]), _vm._v(" "), _c('td', [(_vm.getRecord.financial_session) ? _c('span', [_vm._v(_vm._s(_vm.getRecord.financial_session.session))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Software Version")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.settings_version))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Software Versioning Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.settings_system_javascript_versioning))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Last Daily Cron Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.lastDailyCronDate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Last Daily Interest Cron Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.lastInterestOnlyCronDate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Customer KYC Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.enableMandatoryCustomerKyc))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Send SMS On Customer Registration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.createCustomerSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Send SMS On Password Reset")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.passwordResetSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Due Remainder SMS")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.croneDueReminderSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Member Verify OTP SMS")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.memberVerifyOTPSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Staff Verify OTP SMS")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.staffVerifyOTPSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("No of EMI Remainder SMS Days")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.emiReminderSendSMSDayBefore))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Send SMS Customer Loan Disbursement ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.loanDisbursementSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Send SMS On EMI Collection")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.emiCollectionSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Document Verification SMS")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.documentVerificationSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Customer Credentials SMS")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.customerCredentionSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Guarantor Verify OTP SMS")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.guarantorVerifyOTPSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Staff Verify SMS ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.staffCredentionSMS))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("currency Symbol")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.currencySymbol))])]), _c('tr', [_c('th', [_vm._v("Decimal Places")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.decimalPlaces))])]), _c('tr', [_c('th', [_vm._v("Decimal Places For Amt In Words")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.decimalPlacesForAmtInWords))])]), _c('tr', [_c('th', [_vm._v("Financial Year Begin From")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.financialYearBeginFrom))])]), _c('tr', [_c('th', [_vm._v("Formal Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.formalName))])]), _c('tr', [_c('th', [_vm._v("Word Representing Amt After Decimal")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.wordRepresentingAmtAfterDecimal))])]), _c('tr', [_c('th', [_vm._v("Auto Approve Member Collection Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.autoApproveMemberCollection))])]), _c('tr', [_c('th', [_vm._v("Show All Members")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRecord.showAllMembers))])])]), _vm._v(" "), _c('tbody')])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._v("\n                  Company Profile\n                ")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal-xl"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateProfile()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('name'),
    },
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyName),
      expression: "form.companyName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('companyName'),
    },
    attrs: {
      "type": "text",
      "name": "companyName"
    },
    domProps: {
      "value": (_vm.form.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "companyName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.shortName),
      expression: "form.shortName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('shortName'),
    },
    attrs: {
      "type": "text",
      "name": "shortName"
    },
    domProps: {
      "value": (_vm.form.shortName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "shortName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "shortName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.upiId),
      expression: "form.upiId"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('upiId'),
    },
    attrs: {
      "type": "text",
      "name": "upiId"
    },
    domProps: {
      "value": (_vm.form.upiId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "upiId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "upiId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cibilMemberCode),
      expression: "form.cibilMemberCode"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('cibilMemberCode'),
    },
    attrs: {
      "type": "text",
      "name": "cibilMemberCode"
    },
    domProps: {
      "value": (_vm.form.cibilMemberCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cibilMemberCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "cibilMemberCode"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cibilMemberShortName),
      expression: "form.cibilMemberShortName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('cibilMemberShortName'),
    },
    attrs: {
      "type": "text",
      "name": "cibilMemberShortName"
    },
    domProps: {
      "value": (_vm.form.cibilMemberShortName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cibilMemberShortName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "cibilMemberShortName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.website),
      expression: "form.website"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('website'),
    },
    attrs: {
      "type": "text",
      "name": "website"
    },
    domProps: {
      "value": (_vm.form.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "website", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "website"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.about),
      expression: "form.about"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('about'),
    },
    attrs: {
      "name": "about"
    },
    domProps: {
      "value": (_vm.form.about)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "about", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "about"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.enableMandatoryCustomerKyc),
      expression: "form.enableMandatoryCustomerKyc"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('enableMandatoryCustomerKyc'),
    },
    attrs: {
      "name": "enableMandatoryCustomerKyc"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "enableMandatoryCustomerKyc", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.enableMandatoryCustomerKyc) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select KYC Mandatory Status\n                              ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "enableMandatoryCustomerKyc"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Session"
    }
  }, [_vm._v("Session")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "financial_year_id",
      "label": "name",
      "options": _vm.sessions,
      "placeholder": "Select Session"
    },
    on: {
      "input": _vm.selectSession
    },
    model: {
      value: (_vm.session),
      callback: function($$v) {
        _vm.session = $$v
      },
      expression: "session"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "financial_year_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.url),
      expression: "form.url"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('url'),
    },
    attrs: {
      "type": "text",
      "name": "url"
    },
    domProps: {
      "value": (_vm.form.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "url"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobile),
      expression: "form.mobile"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('mobile'),
    },
    attrs: {
      "type": "text",
      "name": "mobile"
    },
    domProps: {
      "value": (_vm.form.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('phone'),
    },
    attrs: {
      "type": "text",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Landline Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.landline),
      expression: "form.landline"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('landline'),
    },
    attrs: {
      "type": "text",
      "name": "landline"
    },
    domProps: {
      "value": (_vm.form.landline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "landline", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "landline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('address'),
    },
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city),
      expression: "form.city"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('city'),
    },
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.form.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pin),
      expression: "form.pin"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('pin'),
    },
    attrs: {
      "type": "text",
      "name": "pin"
    },
    domProps: {
      "value": (_vm.form.pin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "pin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state),
      expression: "form.state"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('state'),
    },
    attrs: {
      "name": "state"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.state) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select State\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.states), function(stat) {
    return _c('option', {
      key: stat.id,
      domProps: {
        "value": stat.name
      }
    }, [_vm._v("\n                                " + _vm._s(stat.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "state"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('email'),
    },
    attrs: {
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("FAX Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fax),
      expression: "form.fax"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('fax'),
    },
    attrs: {
      "type": "text",
      "name": "fax"
    },
    domProps: {
      "value": (_vm.form.fax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "fax"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("PAN Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pan),
      expression: "form.pan"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('pan'),
    },
    attrs: {
      "type": "text",
      "name": "pan"
    },
    domProps: {
      "value": (_vm.form.pan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pan", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "pan"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Formal Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.formalName),
      expression: "form.formalName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('formalName'),
    },
    attrs: {
      "type": "text",
      "name": "formalName"
    },
    domProps: {
      "value": (_vm.form.formalName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "formalName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "formalName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("GST Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.gstin),
      expression: "form.gstin"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('gstin'),
    },
    attrs: {
      "type": "text",
      "name": "gstin"
    },
    domProps: {
      "value": (_vm.form.gstin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "gstin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "gstin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyClass),
      expression: "form.companyClass"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('companyClass'),
    },
    attrs: {
      "type": "text",
      "name": "companyClass"
    },
    domProps: {
      "value": (_vm.form.companyClass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyClass", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "companyClass"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(22), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.autoApproveMemberCollection),
      expression: "form.autoApproveMemberCollection"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('autoApproveMemberCollection'),
    },
    attrs: {
      "name": "autoApproveMemberCollection"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "autoApproveMemberCollection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.autoApproveMemberCollection) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                  Select Auto Approve Member Collection Status\n                                ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "autoApproveMemberCollection"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(23), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.stateOfRegistration),
      expression: "form.stateOfRegistration"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('stateOfRegistration'),
    },
    attrs: {
      "name": "stateOfRegistration"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "stateOfRegistration", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.stateOfRegistration) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select State of Registration\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.states), function(stat) {
    return _c('option', {
      key: stat.id,
      domProps: {
        "value": stat.name
      }
    }, [_vm._v("\n                                " + _vm._s(stat.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "stateOfRegistration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.authrizedCapital),
      expression: "form.authrizedCapital"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('authrizedCapital'),
    },
    attrs: {
      "type": "text",
      "name": "authrizedCapital"
    },
    domProps: {
      "value": (_vm.form.authrizedCapital)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "authrizedCapital", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "authrizedCapital"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cin),
      expression: "form.cin"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('cin'),
    },
    attrs: {
      "type": "text",
      "name": "cin"
    },
    domProps: {
      "value": (_vm.form.cin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "cin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("TAN Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tan),
      expression: "form.tan"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('tan'),
    },
    attrs: {
      "type": "text",
      "name": "tan"
    },
    domProps: {
      "value": (_vm.form.tan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "tan", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "tan"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(26), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyCategory),
      expression: "form.companyCategory"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('companyCategory'),
    },
    attrs: {
      "type": "text",
      "name": "companyCategory"
    },
    domProps: {
      "value": (_vm.form.companyCategory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyCategory", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "companyCategory"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.incorporationDate),
      expression: "form.incorporationDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('incorporationDate'),
    },
    attrs: {
      "type": "date",
      "name": "incorporationDate"
    },
    domProps: {
      "value": (_vm.form.incorporationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "incorporationDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "incorporationDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(28), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('country'),
    },
    attrs: {
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.form.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(29), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paid_upCapital),
      expression: "form.paid_upCapital"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('paid_upCapital'),
    },
    attrs: {
      "type": "text",
      "name": "paid_upCapital"
    },
    domProps: {
      "value": (_vm.form.paid_upCapital)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paid_upCapital", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paid_upCapital"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Share Nominal Value")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.shareNominalValue),
      expression: "form.shareNominalValue"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('shareNominalValue'),
    },
    attrs: {
      "type": "text",
      "name": "shareNominalValue"
    },
    domProps: {
      "value": (_vm.form.shareNominalValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "shareNominalValue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "shareNominalValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Financial Year Begin From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.financialYearBeginFrom),
      expression: "form.financialYearBeginFrom"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('financialYearBeginFrom'),
    },
    attrs: {
      "type": "date",
      "name": "financialYearBeginFrom"
    },
    domProps: {
      "value": (_vm.form.financialYearBeginFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "financialYearBeginFrom", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "financialYearBeginFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Currency Symbol")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.currencySymbol),
      expression: "form.currencySymbol"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('currencySymbol'),
    },
    attrs: {
      "type": "text",
      "name": "currencySymbol"
    },
    domProps: {
      "value": (_vm.form.currencySymbol)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "currencySymbol", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "currencySymbol"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Decimal Places")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.decimalPlaces),
      expression: "form.decimalPlaces"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('decimalPlaces'),
    },
    attrs: {
      "type": "text",
      "name": "decimalPlaces"
    },
    domProps: {
      "value": (_vm.form.decimalPlaces)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "decimalPlaces", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "decimalPlaces"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Decimal Places For Amt In Words")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.decimalPlacesForAmtInWords),
      expression: "form.decimalPlacesForAmtInWords"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('decimalPlacesForAmtInWords'),
    },
    attrs: {
      "type": "text",
      "name": "decimalPlacesForAmtInWords"
    },
    domProps: {
      "value": (_vm.form.decimalPlacesForAmtInWords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "decimalPlacesForAmtInWords", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "decimalPlacesForAmtInWords"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Word Representing Amt After Decimal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.wordRepresentingAmtAfterDecimal),
      expression: "form.wordRepresentingAmtAfterDecimal"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('wordRepresentingAmtAfterDecimal'),
    },
    attrs: {
      "type": "text",
      "name": "wordRepresentingAmtAfterDecimal"
    },
    domProps: {
      "value": (_vm.form.wordRepresentingAmtAfterDecimal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "wordRepresentingAmtAfterDecimal", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "wordRepresentingAmtAfterDecimal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(30), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.showAllMembers),
      expression: "form.showAllMembers"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('showAllMembers'),
    },
    attrs: {
      "name": "showAllMembers"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "showAllMembers", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.showAllMembers) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                  Select Show All Members Status\n                                ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "showAllMembers"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.enableSMS),
      expression: "form.enableSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "enableSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.enableSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "enableSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "enableSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.enableSMS),
      expression: "form.enableSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "enableSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.enableSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "enableSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "enableSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.createCustomerSMS),
      expression: "form.createCustomerSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "createCustomerSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.createCustomerSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "createCustomerSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "createCustomerSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.createCustomerSMS),
      expression: "form.createCustomerSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "createCustomerSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.createCustomerSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "createCustomerSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "createCustomerSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.passwordResetSMS),
      expression: "form.passwordResetSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "passwordResetSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.passwordResetSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "passwordResetSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "passwordResetSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.passwordResetSMS),
      expression: "form.passwordResetSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "passwordResetSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.passwordResetSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "passwordResetSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "passwordResetSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.croneDueReminderSMS),
      expression: "form.croneDueReminderSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "croneDueReminderSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.croneDueReminderSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "croneDueReminderSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "croneDueReminderSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.croneDueReminderSMS),
      expression: "form.croneDueReminderSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "croneDueReminderSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.croneDueReminderSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "croneDueReminderSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "croneDueReminderSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberVerifyOTPSMS),
      expression: "form.memberVerifyOTPSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "memberVerifyOTPSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.memberVerifyOTPSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "memberVerifyOTPSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberVerifyOTPSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberVerifyOTPSMS),
      expression: "form.memberVerifyOTPSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "memberVerifyOTPSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.memberVerifyOTPSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "memberVerifyOTPSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberVerifyOTPSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.staffVerifyOTPSMS),
      expression: "form.staffVerifyOTPSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "staffVerifyOTPSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.staffVerifyOTPSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "staffVerifyOTPSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staffVerifyOTPSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.staffVerifyOTPSMS),
      expression: "form.staffVerifyOTPSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "staffVerifyOTPSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.staffVerifyOTPSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "staffVerifyOTPSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staffVerifyOTPSMS"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(38), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.emiReminderSendSMSDayBefore),
      expression: "form.emiReminderSendSMSDayBefore"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('emiReminderSendSMSDayBefore'),
    },
    attrs: {
      "type": "text",
      "name": "emiReminderSendSMSDayBefore"
    },
    domProps: {
      "value": (_vm.form.emiReminderSendSMSDayBefore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "emiReminderSendSMSDayBefore", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "emiReminderSendSMSDayBefore"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loanDisbursementSMS),
      expression: "form.loanDisbursementSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "loanDisbursementSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.loanDisbursementSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "loanDisbursementSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loanDisbursementSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loanDisbursementSMS),
      expression: "form.loanDisbursementSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "loanDisbursementSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.loanDisbursementSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "loanDisbursementSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loanDisbursementSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.emiCollectionSMS),
      expression: "form.emiCollectionSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "emiCollectionSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.emiCollectionSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "emiCollectionSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "emiCollectionSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.emiCollectionSMS),
      expression: "form.emiCollectionSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "emiCollectionSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.emiCollectionSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "emiCollectionSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "emiCollectionSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.documentVerificationSMS),
      expression: "form.documentVerificationSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "documentVerificationSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.documentVerificationSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "documentVerificationSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "documentVerificationSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.documentVerificationSMS),
      expression: "form.documentVerificationSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "documentVerificationSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.documentVerificationSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "documentVerificationSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "documentVerificationSMS"
    }
  })], 1)]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" "), _c('strong', [_vm._v("Customer Credentials SMS ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customerCredentionSMS),
      expression: "form.customerCredentionSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "customerCredentionSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.customerCredentionSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "customerCredentionSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "customerCredentionSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customerCredentionSMS),
      expression: "form.customerCredentionSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "customerCredentionSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.customerCredentionSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "customerCredentionSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "customerCredentionSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorVerifyOTPSMS),
      expression: "form.guarantorVerifyOTPSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "guarantorVerifyOTPSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.guarantorVerifyOTPSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "guarantorVerifyOTPSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantorVerifyOTPSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorVerifyOTPSMS),
      expression: "form.guarantorVerifyOTPSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "guarantorVerifyOTPSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.guarantorVerifyOTPSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "guarantorVerifyOTPSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantorVerifyOTPSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.staffCredentionSMS),
      expression: "form.staffCredentionSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "staffCredentionSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.staffCredentionSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "staffCredentionSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staffCredentionSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.staffCredentionSMS),
      expression: "form.staffCredentionSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "staffCredentionSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.staffCredentionSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "staffCredentionSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staffCredentionSMS"
    }
  })], 1)]), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sattlementSMS),
      expression: "form.sattlementSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "sattlementSMS",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.sattlementSMS, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "sattlementSMS", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "sattlementSMS"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sattlementSMS),
      expression: "form.sattlementSMS"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "sattlementSMS",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.sattlementSMS, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "sattlementSMS", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "sattlementSMS"
    }
  })], 1)])])])])])]), _vm._v(" "), _vm._m(45)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border label-primary"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Logo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border label-primary"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Favicon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Update Company Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Company Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Short Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("UPI ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CIBIL Member Code "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CIBIL Member Short Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Website "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("About Company "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Customer KYC Mandatory\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("Reg. Office Address :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("URL "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Contact Number 1\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Contact Number 2\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address"), _c('span', {
    staticClass: "red"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("City "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Pincode "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select State "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Contact Email "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Company Class "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Auto Approve Member Collection\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" State of Registration\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Authorized Capital\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CIN Number "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Company Category\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Incorporation Date\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Incorporation Country\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Paid Up Capital\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Show All Members\n                                "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("SMS Settings :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" SMS Service ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Send SMS Customer Registration ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Send SMS On Password Reset ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Due Remainder SMS ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Member Verify OTP SMS ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Staff Verify OTP SMS ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("No of EMI Remainder SMS Days "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Send SMS Loan Disbursement ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Send SMS On EMI Collection ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Document Verification SMS ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Guarantor Verify OTP SMS ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Staff Credential SMS ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-hand-o-right text-info"
  }), _vm._v(" Settlement SMS ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  SAVE PROFILE\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-704383e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/company/Profile.vue
// module id = 831
// module chunks = 0